export default __webpack_public_path__ + "public/assets/images/a4b4c9c74946d55fef16fea04a80e75f.png";